module.exports = __webpack_public_path__ + "static/img/beizhengshouhu_00.f550afe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beizhengshouhu_00.png
// module id = ZsLP
// module chunks = 1